import { SegmentedControl as MantineSegmentedControl } from '@mantine/core';
import type { SegmentedControlProps as MantineSegmentedControlProps } from '@mantine/core';

import type { LockedProps } from '../types';

type SegmentedControlProps = Omit<MantineSegmentedControlProps, LockedProps>;

/**
 * A linear set of two or more segments
 */
export const SegmentedControl = (props: SegmentedControlProps) => {
  return <MantineSegmentedControl {...props} />;
};
